// Picks the right language from API values like { en: 'First Steps', sk: 'Prvé kroky' }.
export function localize(value, language) {
  if (value && typeof value === 'object') {
    const lang = String(language || 'en').slice(0, 2);
    return value[lang] || value.en || value.sk || '';
  }
  return value || '';
}
